import React from 'react';
import MainLayout from '../layout/MainLayout';
import ConfirmationStep from './steps/ConfirmationStep';

const VendorConfirmationPage = () => (
  <MainLayout>
    <ConfirmationStep />
  </MainLayout>
);

export default VendorConfirmationPage;
